import { Routes } from '@angular/router';
import { authGuard } from './services/guards/auth.guard';
import { CredentialComponent } from './pages/credential/credential.component';
import { EmissionComponent } from './pages/emission/emission.component';
import { HomeComponent } from './pages/home/home.component';
import { LayoutComponent } from './pages/layout/layout.component';
import { LoginComponent } from './pages/login/login.component';
import { PeopleComponent } from './pages/people/people.component';
import { ReportComponent } from './pages/report/report.component';
import { UserComponent } from './pages/user/user.component';
import { HistoryComponent } from './pages/history/history.component';
import { SummaryComponent } from './pages/summary/summary.component';
import { PeopleSearchComponentComponent } from './pages/people/people-search-component/people-search-component.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { ExternalClientTypeComponent } from './pages/externalclient/externalclienttype.component';
import { ExternalClientComponent } from './pages/externalclient/externalclient.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'emission',
        component: EmissionComponent,
        canActivate: [authGuard],
 
      },
      {
        path: 'people',
        component: PeopleComponent,
        canActivate: [authGuard],
      },
      {
        path: 'credential',
        component: CredentialComponent,
        canActivate: [authGuard],
      },
            {
        path: 'peoplesearch',
        component: PeopleSearchComponentComponent,
        canActivate: [authGuard],
      },
      {
        path: 'summary',
        component: SummaryComponent,
        canActivate: [authGuard],
        data: { role: 'ROLE_SUPERUSER' }, // Role necessária para acessar
      },
      {
        path: 'history',
        component: HistoryComponent,
        canActivate: [authGuard],
        data: { role: 'ROLE_ADMIN' }, // Role necessária para acessar
      },
      {
        path: 'dashboard',
        component: DashboardComponent,
        data: { role: 'ROLE_ADMIN' }, // Role necessária para acessar
},
      {
        path: 'users',
        component: UserComponent,
        canActivate: [authGuard],
        data: { role: 'ROLE_ADMIN' }, // Role necessária para acessar
      },
      {
        path: 'externalclienttype',
        component: ExternalClientTypeComponent,
        canActivate: [authGuard],
        data: { role: 'ROLE_ADMIN' }, // Role necessária para acessar
      },
      {
        path: 'externalclient',
        component: ExternalClientComponent,
        canActivate: [authGuard],
        data: { role: 'ROLE_ADMIN' },
      },
    ],
  },

  {
    path: '**',
    redirectTo: '',
   // pathMatch: 'full',
  },
];
